var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography, styled } from '@mui/material';
import { gridClasses } from '@mui/x-data-grid';
import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RumEntityLabel } from '../../../../observability/rumEntity';
import { formatNumberByLocale } from '../../../../util/locale';
import { ColumnFilterHeader, DataGrid, useClientTableFilter } from '../../../common';
import { useSeatAllocationsByLocationAPI } from '../../seats/selectors';
var FooterContainer = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: theme.palette.text.primary,
        color: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
        height: 40,
        borderTop: "1px solid ".concat(theme.palette.divider),
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 'calc(100% - 200px)',
            top: 0,
            bottom: 0,
            width: 1,
            backgroundColor: theme.palette.divider,
        },
    });
});
export var ReviewSeatsSection = function (_a) {
    var _b, _c, _d, _e;
    var location = _a.location, registry = _a.registry, configVersionId = _a.configVersionId;
    var tReview = useTranslation('orgConfig', { keyPrefix: 'orgConfigWizard.reviewStep' }).t;
    var tSeats = useTranslation('orgConfig', { keyPrefix: 'seats' }).t;
    var _f = useSeatAllocationsByLocationAPI(configVersionId), seatsData = _f[0], fetchSeats = _f[1];
    useEffect(function () {
        if (configVersionId)
            fetchSeats();
    }, [configVersionId, fetchSeats]);
    useEffect(function () {
        registry.register('seats', {
            flush: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, true];
            }); }); },
            cancelPending: function () { },
            get isDirty() {
                return false;
            },
        });
        return function () { return registry.unregister('seats'); };
    }, [registry]);
    var isUnlimited = location.totalSeats === null;
    var locationRow = seatsData.data == null ? undefined : (_b = seatsData.data.find(function (r) { return r.locationId === location.id; })) !== null && _b !== void 0 ? _b : null;
    var lobRows = useMemo(function () {
        if (!locationRow)
            return [];
        return locationRow.clients.flatMap(function (client) {
            return client.lobs.map(function (lob) { return ({
                id: "".concat(client.clientId, "-").concat(lob.lobId),
                label: "".concat(client.clientName, ": ").concat(lob.lobName),
                clientId: client.clientId,
                clientName: client.clientName,
                lobId: lob.lobId,
                lobName: lob.lobName,
                reservedSeats: lob.reservedSeats,
            }); });
        });
    }, [locationRow]);
    var filterColumns = useMemo(function () { return [
        { field: 'label', filter: 'text', sortable: true },
        { field: 'reservedSeats', sortable: true },
    ]; }, []);
    var _g = useClientTableFilter({
        rows: lobRows,
        columns: filterColumns,
    }), processedRows = _g.processedRows, getFilterState = _g.getFilterState, getAllValues = _g.getAllValues, applyFilter = _g.applyFilter;
    var makeFilterHeader = useCallback(function (field, label) { return function () { return (_jsx(ColumnFilterHeader, { label: label, filterState: getFilterState(field), allValues: getAllValues(field), onApply: function (update) { return applyFilter(field, update); } })); }; }, [applyFilter, getAllValues, getFilterState]);
    var columns = useMemo(function () { return [
        {
            field: 'label',
            headerName: tSeats('table.lob', { defaultValue: 'LOB' }),
            flex: 1,
            sortable: false,
            renderHeader: makeFilterHeader('label', tSeats('table.lob', { defaultValue: 'LOB' })),
            // Renders the same text as `label`, with each name wrapped so Datadog shows its id instead of a mask.
            renderCell: function (_a) {
                var row = _a.row, formattedValue = _a.formattedValue;
                return (_jsxs("div", __assign({ className: gridClasses.cellContent, title: formattedValue !== null && formattedValue !== void 0 ? formattedValue : undefined }, { children: [_jsx(RumEntityLabel, __assign({ kind: "client", id: row.clientId }, { children: row.clientName })), ': ', _jsx(RumEntityLabel, __assign({ kind: "lob", id: row.lobId }, { children: row.lobName }))] })));
            },
        },
        {
            field: 'reservedSeats',
            headerName: tSeats('table.reservedSeats', { defaultValue: 'Reserved Seats' }),
            width: 200,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            renderHeader: makeFilterHeader('reservedSeats', tSeats('table.reservedSeats', { defaultValue: 'Reserved Seats' })),
            renderCell: function (_a) {
                var value = _a.value;
                return formatNumberByLocale(value !== null && value !== void 0 ? value : 0);
            },
        },
    ]; }, [tSeats, makeFilterHeader]);
    if (locationRow === undefined)
        return null;
    var totalSeats = (_c = locationRow === null || locationRow === void 0 ? void 0 : locationRow.totalSeats) !== null && _c !== void 0 ? _c : location.totalSeats;
    var locationName = (_d = locationRow === null || locationRow === void 0 ? void 0 : locationRow.locationName) !== null && _d !== void 0 ? _d : location.locationName;
    var reservedSeats = (_e = locationRow === null || locationRow === void 0 ? void 0 : locationRow.reservedSeats) !== null && _e !== void 0 ? _e : 0;
    var seatsLabel = totalSeats == null
        ? tSeats('unlimited', { defaultValue: 'Unlimited' })
        : tReview('totalSeatCount', { total: formatNumberByLocale(totalSeats), defaultValue: '{{total}} Seats' });
    var totalReservedLabel = isUnlimited && reservedSeats === 0
        ? tSeats('unlimited', { defaultValue: 'Unlimited' })
        : formatNumberByLocale(reservedSeats);
    return (_jsxs(Stack, __assign({ spacing: 2 }, { children: [_jsx(Typography, __assign({ color: "text.secondary" }, { children: seatsLabel })), _jsxs(Box, __assign({ sx: { borderRadius: '6px', overflow: 'hidden' } }, { children: [_jsx(DataGrid, { hideFooter: true, autoHeight: true, rowHeight: 40, rows: processedRows, columns: columns, sx: { borderRadius: 0 } }), _jsxs(FooterContainer, { children: [_jsx(Typography, __assign({ color: "inherit", fontWeight: "bold", sx: { flex: 1, pl: 2 } }, { children: tReview('totalReservedSeats', {
                                    locationName: locationName,
                                    defaultValue: 'Total Reserved Seats in {{locationName}}',
                                }) })), _jsx(Typography, __assign({ color: "inherit", fontWeight: "bold", sx: { width: 200, textAlign: 'center' } }, { children: totalReservedLabel }))] })] }))] })));
};
